<div class="nav" [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}">

    <!-- Vertical Navigation Layout -->
    <ng-container *ngIf="layout === 'vertical'">

        <ng-container *ngFor="let item of navigation">

            <fuse-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></fuse-nav-vertical-group>
            <fuse-nav-vertical-collapsable *ngIf="item.type=='collapsable'"
                [item]="item"></fuse-nav-vertical-collapsable>
            <fuse-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></fuse-nav-vertical-item>

        </ng-container>

    </ng-container>
    <!-- / Vertical Navigation Layout -->

    <!-- Horizontal Navigation Layout -->
    <ng-container *ngIf="layout === 'horizontal'">

        <ng-container *ngFor="let item of navigation">

            <fuse-nav-horizontal-collapsable *ngIf="item.type=='group'" [item]="item"></fuse-nav-horizontal-collapsable>
            <fuse-nav-horizontal-collapsable *ngIf="item.type=='collapsable'"
                [item]="item"></fuse-nav-horizontal-collapsable>
            <fuse-nav-horizontal-item *ngIf="item.type=='item'" [item]="item"></fuse-nav-horizontal-item>

        </ng-container>

    </ng-container>
    <!-- / Horizontal Navigation Layout -->
    <!-- <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center" style="display: flex; align-items: center;">
            <img [src]="GetprofileImage ? GetprofileImage : 'assets/images/avatars/profile4.png'"
                class="avatar mr-0 mr-sm-16" onerror="this.src='assets/images/avatars/profile4.png'" />
    
            <span class="username mr-12 text-capitalize" fxHide fxShow.gt-sm>{{userName}}</span>
            <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </div>
    </button> -->

    <button mat-button [matMenuTriggerFor]="userMenu" class="user-button" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()">
        <div fxLayout="row" fxLayoutAlign="center center" style="display: flex; align-items: center;">
            <img [src]="GetprofileImage ? GetprofileImage : 'assets/images/avatars/profile4.png'"
                class="avatar mr-0 mr-sm-16" onerror="this.src='assets/images/avatars/profile4.png'" />

            <span class="username mr-12 text-capitalize" fxHide fxShow.gt-sm>{{ userName }}</span>
            <mat-icon class="s-16" fxHide.xs>{{ isMenuOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </div>
    </button>

    <mat-menu #userMenu="matMenu" [overlapTrigger]="false" class="user-menu">

        <button mat-menu-item (click)="myprofile()" *ngIf="!isAdmin ">
            <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>

            <span>My Profile</span>
        </button>
        <button mat-menu-item (click)="changeuser()">
            <mat-icon matSuffix class="secondary-text">account_box</mat-icon>

            <span>Change Username</span>
        </button>
        <button mat-menu-item (click)="changePass()">
            <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>

            <span>Change Password</span>
        </button>


        <button mat-menu-item class="" (click)="onLogout()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Logout</span>
        </button>

    </mat-menu>

</div>